<template>
  <div>
    <NavBar
      :narBarTitle="$t('忘记密码')"
      :showLogo="true"
      :companyCode="companyCode"
    />
    <van-form @submit="onFindPwd" class="findPwdForm">
      <div class="errSpace">
        <van-field
          v-model="mobile"
          clearable
          name="mobile"
          :placeholder="$t('请输入手机号')"
          :rules="[{ required: true, validator: mobileTest }]"
          @blur="verifyMobile"
        />
        <span v-show="mobileErr" class="error">{{
          $t('请输入正确的手机号')
        }}</span>
      </div>
      <div class="errSpace">
        <van-field
          v-model="code"
          center
          clearable
          name="code"
          class="form-spacing form-spacing-code"
          :placeholder="$t('请输入验证码')"
        >
          <template #button>
            <van-button
              size="small"
              type="info"
              :disabled="!modelSms"
              @click="onSend"
              class="code-btn"
              :style="{ color: smsColor ? '#009BFF' : '#CCCCCC' }"
              >{{ smsTitle }}</van-button
            >
          </template>
        </van-field>
      </div>
      <div class="errSpace">
        <van-field
          v-model="password"
          :type="seen ? 'password' : 'text'"
          center
          clearable
          name="password"
          :placeholder="$t('请输入密码')"
          autocomplete="“off”"
          class="form-spacing"
          :rules="[{ required: true, validator: pwdTest }]"
          @blur="verifyPwd"
        >
          <template #right-icon>
            <div @click="changeSeen" class="visible-btn">
              <img v-if="eye" src="@/assets/images/invisible.png" alt="" />
              <img v-else src="@/assets/images/visible.png" alt="" />
            </div>
          </template>
        </van-field>
        <span v-show="pwdErr" class="error">{{ $t('请输入正确的密码') }}</span>
      </div>
      <div class="errSpace">
        <van-field
          v-model="checkPassword"
          :type="seen ? 'password' : 'text'"
          class="form-spacing"
          center
          clearable
          name="checkPwd"
          :placeholder="$t('请再次输入新密码')"
          autocomplete="“off”"
          :rules="[{ required: true, validator: checkTest }]"
          @blur="verifyCheckPwd"
        >
          <template #right-icon>
            <div @click="changeSeen" class="visible-btn">
              <img v-if="eye" src="@/assets/images/invisible.png" alt="" />
              <img v-else src="@/assets/images/visible.png" alt="" />
            </div>
          </template>
        </van-field>
        <span v-show="checkPwdErr" class="error">{{
          $t('两次密码不一致')
        }}</span>
      </div>
      <div class="passwordNotice">
        <span><img src="@/assets/images/notice.png" alt="" /></span>
        <p>
          {{
            $t(
              '密码修改要求必须包含数字、⼤写字母、⼩写字母、特殊字符4种中⾄少3种，且不少于8位'
            )
          }}
        </p>
      </div>
      <div class="confirmBox">
        <van-button
          round
          block
          type="info"
          native-type="submit"
          :disabled="!codeFindPwdTest"
          class="confirm-btn"
          :style="{ background: codeFindPwdTest ? '#009BFF' : '#DDDDDD' }"
          >{{ $t('确认') }}</van-button
        >
      </div>
    </van-form>
    <!-- <van-number-keyboard
      v-model="code"
      :show="showKeyboardCode"
      @blur="showKeyboardCode = false"
      safe-area-inset-bottom
    /> -->
  </div>
</template>
<script>
import NavBar from '@/components/navBar'
import { getVerifyCode, updatePwd } from '@/services/api'
import { verifyPassword } from '@/utils/utils'
import Vue from 'vue'
import { Form, Field, Button, Toast, Icon, NumberKeyboard } from 'vant'
Vue.use(Form)
Vue.use(Field)
Vue.use(Button)
Vue.use(Toast)
Vue.use(Icon)
Vue.use(NumberKeyboard)

export default {
  name: 'FindPwd',
  components: {
    NavBar,
  },
  data() {
    return {
      mobile: '',
      code: '',
      password: '',
      checkPassword: '',
      showKeyboardCode: false,
      checkPwdErr: false,
      pwdErr: false,
      smsTitle: this.$t('获取验证码'),
      seen: true,
      eye: true,
      mobileErr: false,
      companyCode: '',
    }
  },
  methods: {
    mobileTest() {
      return /^1[3-9]\d{9}$/.test(this.mobile)
    },
    pwdTest() {
      return verifyPassword(this.password)
    },
    checkTest() {
      return this.password === this.checkPassword
    },
    changeSeen() {
      this.seen = !this.seen
      this.eye = !this.eye
    },
    codeTest() {
      return /^\d{6}$/.test(this.code)
    },
    onSend() {
      let time = 60
      this.smsTitle = time + 's'
      const t = setInterval(() => {
        if (time === 1) {
          clearInterval(t)
          this.smsTitle = this.$t('重新获取')
        } else {
          time--
          this.smsTitle = time + 's'
        }
      }, 1000)
      getVerifyCode({
        mobile: this.mobile,
        plate: 'NEW_WORK',
        time: 600,
      })
    },
    async onFindPwd(v) {
      try {
        await updatePwd({
          companyCode: this.companyCode,
          ...v,
        })
        Toast.success(this.$t('设置密码成功'))
        localStorage.removeItem('user')
        this.$router.push(`/login?companyCode=${this.companyCode}`)
      } catch (error) {
        Toast.fail(error.response.data.message)
      }
    },
    async verifyMobile() {
      if (this.mobileTest()) {
        this.mobileErr = false
      } else {
        this.mobileErr = true
      }
    },
    verifyPwd() {
      if (this.pwdTest()) {
        this.pwdErr = false
      } else {
        this.pwdErr = true
      }
    },
    verifyCheckPwd() {
      if (this.checkTest()) {
        this.checkPwdErr = false
      } else {
        this.checkPwdErr = true
      }
    },
  },
  computed: {
    codeFindPwdTest() {
      return (
        this.mobileTest() === true &&
        this.codeTest() === true &&
        this.pwdTest() === true &&
        this.checkTest() === true
      )
    },
    modelSms() {
      return (
        this.mobileTest() === true &&
        (this.smsTitle == this.$t('获取验证码') ||
          this.smsTitle == this.$t('重新获取'))
      )
    },
    smsColor() {
      return this.mobileTest() === true
    },
  },
  created() {
    this.companyCode =
      this.$route.query.companyCode ||
      JSON.parse(localStorage.getItem('companyCode')).code
  },
}
</script>
<style lang="less" scoped>
.findPwdForm {
  margin: 62px 8px 0px;
  .code-btn {
    background: none;
    border: none;
    font-size: 14px;
    display: flex;
  }
  .confirm-btn {
    border: none;
    font-size: 16px;
  }

  .form-spacing {
    margin-top: 12px;
  }
  .visible-btn {
    background: none;
    border: none;
    font-size: 14px;
    display: flex;
    img {
      width: 16px;
      height: 16px;
    }
  }
  .confirmBox {
    padding-top: 48px;
    width: 280px;
    height: 44px;
    margin: 0 40px;
  }
}
.errSpace {
  height: 67px;
  padding-bottom: 24px;
}
.error {
  height: 24px;
  font-size: 12px;
  color: #e02020;
  line-height: 24px;
  padding-left: 16px;
}
/deep/.form-spacing {
  margin-top: 12px;
  // .van-cell__value{
  //   border-bottom: 1px solid #ECECEC;
  // }
}
/deep/.form-spacing-code {
  .van-cell__value {
    border-bottom: 1px solid #ececec;
  }
}

.passwordNotice {
  display: flex;
  padding: 0 20px;
  p {
    font-size: 13px;
    color: #00000061;
  }
  img {
    width: 22px;
    height: 22px;
    margin-top: -2px;
  }
}
</style>
